import React from "react";
import LoadingSpinner from "../components/LoadingSpinner";

const ProgressTab = ({
  courseProgressData,
  loading,
  courseProgressPagination,
  progressFilters,
  availableCourses,
  onProgressFilterChange,
  onClearProgressFilters,
  onFetchCourseProgress,
  onExportCourseProgressCSV,
  formatDate,
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Progresso dos Cursos</h2>
          <p className="text-gray-600">Visualize o progresso dos usuários nos cursos</p>
        </div>
        <div className="flex space-x-4">
          <button
            onClick={() => {
              if (onExportCourseProgressCSV) {
                onExportCourseProgressCSV();
              } else {
                console.error("onExportCourseProgressCSV is not defined");
              }
            }}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            Exportar CSV
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="mb-6 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Filtrar por Curso
            </label>
            <select
              value={progressFilters.course_filter || ""}
              onChange={(e) => {
                onProgressFilterChange("course_filter", e.target.value);
                onFetchCourseProgress(1, e.target.value, progressFilters.user_filter);
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Todos os cursos</option>
              {availableCourses && availableCourses.length > 0 ? (
                availableCourses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.title}
                  </option>
                ))
              ) : (
                <option value="" disabled>Carregando cursos...</option>
              )}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Buscar Usuário</label>
            <input
              type="text"
              value={progressFilters.user_filter || ""}
              onChange={(e) => onProgressFilterChange("user_filter", e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onFetchCourseProgress(1, progressFilters.course_filter, e.target.value);
                }
              }}
              placeholder="Nome ou email do usuário"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div className="flex items-end space-x-2">
            <button
              onClick={() => onFetchCourseProgress(1, progressFilters.course_filter, progressFilters.user_filter)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Pesquisar
            </button>
            <button
              onClick={onClearProgressFilters}
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg transition-colors duration-200"
            >
              Limpar Filtros
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <LoadingSpinner message="Carregando progresso..." />
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      // TODO: Implement sorting
                    }}
                  >
                    Nome do Curso
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      // TODO: Implement sorting
                    }}
                  >
                    Usuário
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      // TODO: Implement sorting
                    }}
                  >
                    Progresso Atual
                  </th>
                  <th
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      // TODO: Implement sorting
                    }}
                  >
                    Data do Último Check
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {courseProgressData.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="px-6 py-12 text-center text-gray-500">
                      <div className="flex flex-col items-center">
                        <svg
                          className="w-12 h-12 text-gray-400 mb-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                          />
                        </svg>
                        <p className="text-lg font-medium text-gray-900 mb-2">
                          Nenhum progresso encontrado
                        </p>
                        <p className="text-gray-500">
                          Os dados de progresso dos usuários aparecerão aqui
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  courseProgressData.map((progress, index) => (
                    <tr key={`${progress.user_id}-${progress.course_id}`}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {progress.course_title}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-sm font-semibold">
                              {progress.user_name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">
                              {progress.user_name}
                            </div>
                            <div className="text-sm text-gray-500">{progress.user_email}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-1 mr-4">
                            <div className="flex items-center justify-between text-sm mb-1">
                              <span className="font-medium text-gray-900">
                                {progress.progress_percentage}%
                              </span>
                              <span className="text-gray-500">
                                {progress.completed_videos_count}/{progress.total_videos} vídeos
                              </span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className={`h-2 rounded-full transition-all duration-300 ${
                                  progress.progress_percentage === 100
                                    ? "bg-green-500"
                                    : progress.progress_percentage >= 50
                                    ? "bg-blue-500"
                                    : "bg-gray-400"
                                }`}
                                style={{ width: `${progress.progress_percentage}%` }}
                              ></div>
                            </div>
                          </div>
                          <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              progress.progress_percentage === 100
                                ? "bg-green-100 text-green-800"
                                : progress.progress_percentage >= 50
                                ? "bg-blue-100 text-blue-800"
                                : progress.progress_percentage > 0
                                ? "bg-yellow-100 text-yellow-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {progress.progress_percentage === 100
                              ? "Concluído"
                              : progress.progress_percentage >= 50
                              ? "Em Progresso"
                              : progress.progress_percentage > 0
                              ? "Iniciado"
                              : "Não Iniciado"}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {progress.last_updated ? formatDate(progress.last_updated) : "Nunca"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          {courseProgressData.length > 0 && (
            <div className="px-6 py-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                  Mostrando{" "}
                  {(courseProgressPagination.current_page - 1) * courseProgressPagination.per_page +
                    1}{" "}
                  até{" "}
                  {Math.min(
                    courseProgressPagination.current_page * courseProgressPagination.per_page,
                    courseProgressPagination.total
                  )}{" "}
                  de {courseProgressPagination.total} resultados
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() =>
                      onFetchCourseProgress(
                        courseProgressPagination.current_page - 1,
                        progressFilters.course_filter,
                        progressFilters.user_filter
                      )
                    }
                    disabled={!courseProgressPagination.has_prev}
                    className={`px-3 py-1 rounded text-sm ${
                      courseProgressPagination.has_prev
                        ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                        : "bg-gray-50 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Anterior
                  </button>

                  {/* Page numbers */}
                  {Array.from(
                    { length: Math.min(5, courseProgressPagination.total_pages) },
                    (_, i) => {
                      const startPage = Math.max(1, courseProgressPagination.current_page - 2);
                      const pageNumber = startPage + i;
                      if (pageNumber <= courseProgressPagination.total_pages) {
                        return (
                          <button
                            key={pageNumber}
                            onClick={() =>
                              onFetchCourseProgress(
                                pageNumber,
                                progressFilters.course_filter,
                                progressFilters.user_filter
                              )
                            }
                            className={`px-3 py-1 rounded text-sm ${
                              pageNumber === courseProgressPagination.current_page
                                ? "bg-blue-600 text-white"
                                : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                            }`}
                          >
                            {pageNumber}
                          </button>
                        );
                      }
                      return null;
                    }
                  )}

                  <button
                    onClick={() =>
                      onFetchCourseProgress(
                        courseProgressPagination.current_page + 1,
                        progressFilters.course_filter,
                        progressFilters.user_filter
                      )
                    }
                    disabled={!courseProgressPagination.has_next}
                    className={`px-3 py-1 rounded text-sm ${
                      courseProgressPagination.has_next
                        ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                        : "bg-gray-50 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Próximo
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressTab;
